import { Card, Col, DatePicker, Form, Input, Row, Typography } from "antd";
import dayjs from 'dayjs';
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const dateFormat = 'MM/DD/YYYY';

const PatientInformation = ({ getChildData }) => {
  const { t, i18n } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
  };

  const validationRules = useMemo(() => ({
    firstName: [
      { required: true, max: 50, message: t("singleRequest:please_enter_patient_first_name") }
    ],
    lastName: [
      { required: true, max: 50, message: t("singleRequest:please_enter_patient_last_name") }
    ],
    dob: [
      { required: true, message: t("singleRequest:please_enter_date_of_birth") }
    ],
    email: [
      { max: 100, message: t("common:please_enter_email") },
      { type: "email", message: t("common:please_enter_valid_email") }
    ]
  }), [t]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("singleRequest:patient_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="ffirstname"
            label={t("singleRequest:patient_first_name")}
            onChange={(e) => callparent(e.target.value, "PatientFirstName")}
            required
            rules={validationRules.firstName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:patient_last_name")}
            name="lastname"
            onChange={(e) => callparent(e.target.value, "PatientLastName")}
            required
            rules={validationRules.lastName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="dob"
            label={t("singleRequest:date_of_birth")}
            required
            rules={validationRules.dob}
          >
            <DatePicker
              disabledDate={disableFutureDates}
              format={dateFormat}
              style={{ minWidth: "100%" }}
              onChange={(e) => callparent(e, "PatientDOB")}
              placeholder={t("common:select_date")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("common:email")}
            name="Pemail"
            onChange={(e) => callparent(e.target.value, "PatientEmail")}
            rules={validationRules.email}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default PatientInformation;
